<template>
  <r-button
    size="16px"
    align="left"
    padding="12px"
    outline
    unelevated
    custom-class="full-width"
    v-on="$listeners" >
    <r-icon name="article" class="flip-horizontal article-icon" />
    <span class="r-text-regular">{{ label }}</span>
  </r-button>
</template>

<script>
import RButton from '@/components/base/RButton';
import RIcon from '@/components/base/RIcon';

export default {
  name: 'ArticleButton',
  components: { RIcon, RButton },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.article-icon {
  margin-right: 15px;
}
</style>
